/**
 * Query parameters that carry a guest's personal details.
 *
 * The iOS and Android apps open the booking flow with the logged-in
 * guest's details in the URL so the form is prefilled. They are read once
 * (components/layout.tsx) and then removed from the address bar, so they
 * don't follow the guest into later page views, analytics events,
 * referrer headers or the "landing page" stored on the reservation.
 * The proper fix is passing them over the webview bridge (PN-6764).
 */
export const PERSONAL_QUERY_PARAMS = ['phone', 'name', 'email', 'emailConsent'];

export function hasPersonalParams(query: Record<string, unknown>): boolean {
  return PERSONAL_QUERY_PARAMS.some((key) => query[key] !== undefined);
}

export function withoutPersonalParams<T extends Record<string, unknown>>(query: T): Partial<T> {
  const rest: Partial<T> = { ...query };
  PERSONAL_QUERY_PARAMS.forEach((key) => {
    delete rest[key];
  });
  return rest;
}

/** A "?a=b" search string without the personal parameters ("" when nothing is left). */
export function searchWithoutPersonalParams(search: string): string {
  const params = new URLSearchParams(search);
  PERSONAL_QUERY_PARAMS.forEach((key) => params.delete(key));
  const rest = params.toString();
  return rest ? `?${rest}` : '';
}
